/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/no-runloop, ember/require-computed-property-dependencies, ember/require-tagless-components */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import {
  getMilestoneSetOptions,
  getDefaultMilestoneSet,
} from 'linced-app/utils/progressions-analysis';
import { classNames } from '@ember-decorators/component';

@classNames('layout-row', 'layout-align-end-center')
export default class MilestoneSetFilter extends Component {
  @service
  personOptions;

  defaultMilestones = null;
  milestoneSets = null;
  selected = null;
  skipDefault = false;
  onChange() {}

  @alias('personOptions.defaultMilestoneSet')
  defaultMilestoneSet;

  @computed('defaultMilestoneSet', 'selected.{id,isDefault}')
  get defaultIsSelected() {
    if (isEmpty(this.defaultMilestoneSet)) {
      // The user doesn't have a default set.
      return false;
    }
    if (
      this.defaultMilestoneSet === 'default' &&
      this.get('selected.isDefault')
    ) {
      // User has set their default to the "Default Milestones" faux-Set, which
      // is currently selected.
      return true;
    }
    return this.defaultMilestoneSet === this.get('selected.id');
  }

  @computed('milestones.[]', 'milestoneSets.[]')
  get milestoneSetOptions() {
    return getMilestoneSetOptions(this.milestoneSets, this.defaultMilestones);
  }

  selectDefaultMilestoneSet() {
    if (isEmpty(this.selected) && !this.skipDefault) {
      let milestoneSet = getDefaultMilestoneSet(
        this.milestoneSetOptions,
        this.defaultMilestoneSet,
      );
      this.onChange(milestoneSet);
    }
  }

  init() {
    super.init(...arguments);
    // If no Milestone Set is preselected, select one based on user preference.
    next(this, 'selectDefaultMilestoneSet');
  }

  @action
  selectMilestoneSet(milestoneSet) {
    this.onChange(milestoneSet);
  }

  @action
  saveDefault() {
    let id = this.get('selected.id');
    if (this.get('selected.isDefault')) {
      id = 'default';
    }
    this.personOptions.setDefaultMilestoneSet(id);
  }
}
